/* Khayest reusable News section — tab filtering.
   Custom element: <khayest-news>. Each [data-news-tab] controls the matching
   [data-news-panel] (via aria-controls). Accessible (roving tabindex + arrow keys). */
if (!customElements.get('khayest-news')) {
  customElements.define(
    'khayest-news',
    class KhayestNews extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-news-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-news-panel]'));
        if (!this.tabs.length) return;

        this.addEventListener('click', (e) => {
          const tab = e.target.closest('[data-news-tab]');
          if (tab && this.contains(tab)) {
            e.preventDefault();
            this.activate(tab);
          }
        });

        this.addEventListener('keydown', (e) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
          const current = document.activeElement;
          if (!current || !current.matches('[data-news-tab]')) return;
          e.preventDefault();
          const i = this.tabs.indexOf(current);
          let next = i;
          if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
          if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = this.tabs.length - 1;
          this.activate(this.tabs[next]);
          this.tabs[next].focus();
        });
      }

      activate(tab) {
        const targetId = tab.getAttribute('aria-controls');
        this.tabs.forEach((t) => {
          const selected = t === tab;
          t.classList.toggle('is-active', selected);
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.setAttribute('tabindex', selected ? '0' : '-1');
        });
        this.panels.forEach((p) => {
          const show = p.id === targetId;
          p.classList.toggle('is-active', show);
          p.toggleAttribute('hidden', !show);
        });
      }
    }
  );
}
